<template>
  <div class="statement-tips ant-modal-content" :class="{ show: statementTipsVisible, hasOther: importTipsVisible }">
    <div class="ant-modal-close">
      <span class="ant-modal-close-x" @click="onClose()">
        <a-icon type="close" />
      </span>
    </div>
    <div class="ant-modal-header">
      <div class="ant-modal-title">
        <!-- 执行成功 -->
        <span v-if="result.status===2">
          <a-icon type="check-circle"/> 执行合并成功！
        </span>
        <!-- 执行中 -->
        <span v-else-if="result.status===1">
          <a-icon type="clock-circle" />执行合并中
        </span>
        <span v-else>
          <a-icon type="close-circle" />执行合并失败！
        </span>
      </div>
    </div>
    <div class="ant-modal-body">
      【{{result.name}}】
      <span v-if="result.status===2">执行合并成功</span>
      <span v-else-if="result.status===1">执行合并中</span>
      <span v-else>执行合并失败</span>
    </div>
    <div class="ant-modal-footer">
      <a-button type="link" @click="onDetail()">查看详情</a-button>
      <a-button type="link" @click="onClose()">关闭</a-button>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    result() {
      return this.$store.state.user.statementExecuteResult
    },
    importTipsVisible() {
      return this.$store.state.user.importTipsVisible
    },
    statementTipsVisible() {
      return this.$store.state.user.statementTipsVisible
    }
  },
  watch: {},
  methods: {
    onClose() {
      this.$store.commit('setStatementTipsVisible', false)
    },
    onDetail() {
      const { consolidatedPeriod, consolidatedSchemeId, consolidatedSystemVersionDetailId } = this.result
      if (consolidatedPeriod && consolidatedSchemeId) {
        this.$router.push({ path: '/crs/consolidated_execute/consolidated_monitor', query: { period: consolidatedPeriod, schemeId: consolidatedSchemeId, id: consolidatedSystemVersionDetailId } })
        this.$store.commit('setStatementTipsVisible', false)
      }
    }
  }
}
</script>
<style lang="less">
.statement-tips {
  width: 500px;
  min-height: 180px;
  position: fixed!important;
  bottom: 20px;
  right: -520px;
  transition: right 0.5s ease-in-out;
  &.hasOther {
    bottom: 260px;
  }
  .ant-modal-title {
    .anticon {
      margin-right: 5px;
      font-size: 16px;
    }
    &.error {
      color: #FB5146;
    }
    .anticon-check-circle {
      color: #1cb09f;
    }
    .anticon-clock-circle {
      color: #007AFE;
    }
    .anticon-close-circle {
      color: #FB5146;
    }
  }
  .ant-modal-body {
    padding: 20px;
  }

  &.show {
    right: 20px;
  }
  .ant-modal-footer {
    height: 32px;
    padding: 5px 0px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
